/**
 * Returns result that input string is xml
 * {@link https://github.com/jquery/jquery/blob/master/src/ajax/parseXML.js jquery parseXML}
 *
 * @param {string} string
 * @returns {boolean}
 */
export default function isXMLString(string = '') {
    if (typeof string !== 'string') {
        return false;
    }

    string = string.trim().replace(/\u23CE/g, '');

    if (!string || string.indexOf('<') < 0) {
        return false;
    }

    try {
        const xml = (new window.DOMParser()).parseFromString(string, 'text/xml');
        return xml.getElementsByTagName('parsererror').length === 0;
    } catch (e) {
        return false;
    }
}
